import { render, staticRenderFns } from "./TourWidget.vue?vue&type=template&id=15ce29dc"
import script from "./TourWidget.vue?vue&type=script&lang=js"
export * from "./TourWidget.vue?vue&type=script&lang=js"
import style0 from "./TourWidget.vue?vue&type=style&index=0&id=15ce29dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports